import React from 'react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';

export default function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69b2907c6ea2c641fd46240c/8e8026a6b_ChatGPTImageMar12202603_24_58AM.png" alt="Bridge Logo" className="w-9 h-9 object-contain" />
              <span className="text-white text-xl font-bold tracking-tight">Bridge</span>
            </div>
            <p className="text-slate-400 leading-relaxed max-w-sm">
              Helping local businesses harness the power of AI through expert data preparation and seamless integration.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Pages</h4>
            <ul className="space-y-3">
              {['About', 'Services', 'Contact'].map(page => (
                <li key={page}>
                  <Link to={createPageUrl(page)} className="text-slate-400 hover:text-white transition-colors text-sm">
                    {page}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-3">
              <li className="text-slate-400 text-sm">Data Labeling</li>
              <li className="text-slate-400 text-sm">AI Integration</li>
              <li className="text-slate-400 text-sm">Domain Training</li>
              <li className="text-slate-400 text-sm">Consulting</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">© 2026 Bridge. All rights reserved.</p>
          <div className="flex gap-6">
            <span className="text-slate-500 text-sm hover:text-slate-300 cursor-pointer transition-colors">Privacy</span>
            <span className="text-slate-500 text-sm hover:text-slate-300 cursor-pointer transition-colors">Terms</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
